var map = {
	"./action_shap.png": 326,
	"./author_img.png": 327,
	"./banner_bg.png": 191,
	"./banner_img.png": 192,
	"./divider.png": 193,
	"./dot.png": 194,
	"./icon01-old.png": 328,
	"./icon01.png": 329,
	"./icon02 - Copy.png": 330,
	"./icon02.png": 331,
	"./icon3 - Copy.png": 332,
	"./icon3.png": 333,
	"./icon_04.png": 334,
	"./icon_05.png": 335,
	"./icon_shape1.png": 336,
	"./icon_shape2.png": 337,
	"./icon_shape3.png": 338,
	"./icon_shape4.png": 339,
	"./process-divider.png": 195,
	"./process_1.png": 340,
	"./process_2.png": 341,
	"./process_3.png": 342,
	"./process_4.png": 343,
	"./process_5.png": 344,
	"./shape.png": 345,
	"./team1.jpg": 52,
	"./team2.jpg": 26,
	"./work1.png": 346,
	"./work2.png": 347,
	"./work3.png": 348
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 212;